var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page --compatible" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("h1", [
          _vm._v(
            _vm._s(
              _vm.__("Looks like we're compatible!", "bluehost-site-migrator")
            )
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.__(
                "We need to make a clone of your WordPress website next, which we can then use to transfer to your desired account.",
                "bluehost-site-migrator"
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(
                _vm.__(
                  "Please wait to make changes to your website until the transfer process has been completed. In addition, for now, leave your DNS and domain settings the same as well.",
                  "bluehost-site-migrator"
                )
              ) +
              "\n\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.__(
                "Once the cloning process is completed, you will be given a transfer key that can be copied and used to complete the WordPress website transfer process.",
                "bluehost-site-migrator"
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          { staticClass: "button", attrs: { to: "/transfer", tag: "button" } },
          [_vm._v(_vm._s(_vm.__("Start Transfer", "bluehost-site-migrator")))]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("img", { attrs: { src: _vm.imageSrc } }),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }